import { Injectable } from '@angular/core';
import { LMToolbarServiceBase } from '@toolbar/lm-toolbar-service.base';
import { LMToolbarServiceAdapter } from '@toolbar/lm-toolbar-service-adapter';
import { LMConfigurationService, LMContextService } from '@app/services';

@Injectable()
export class LMSettingsToolbarService extends LMToolbarServiceBase {
  actionRefArray: Array<LMBusActionReference>;

  constructor(
    public lmToolbarServiceAdapter: LMToolbarServiceAdapter,
    public lmConfigurationService: LMConfigurationService,
    public lmContextService: LMContextService,
    ) {
    super(lmToolbarServiceAdapter); // must msg the base class constructor
  }

  public buildToolbar(actionRefArray: Array<LMBusActionReference>): void {
    this.actionRefArray = actionRefArray;
    this.toolbarButtons = this.reportsActionRefArrayToToolbarButtonArray(this.actionRefArray);
    this.updateToolbarState(true);
  }

  private reportsActionRefArrayToToolbarButtonArray(actionRefArray: LMBusActionReference[]): LMToolbarButton[] {
    return actionRefArray.map(actionRef =>
        this.buildLMToolbarButton(null, actionRef, true, true, false));
  }

  public updateToolbarState(state: boolean) {
    this.toolbarButtons[0].state.disabled = state;
    this.fireToolbarObservable();
  }
}